module.exports = __webpack_public_path__ + "img/subject_07.jpg";